import { Button, Radio, Select, Space } from "antd";
import "./customtable.less";
import { FILTER_TYPES, FILTER_TYPES_DICTIONARY, getInput } from "./helper";

const PPTableFilter = props => {
	const {
		searchParams,
		handleChangeFilterValue,
		handleChangeFilterOperator,
		resetFilter,
		column = {},
		fetchList,
		dataIndex,
		close,
		tableState
	} = props;

	const dataType = column.instance;

	const { filter } = searchParams ?? {};
	const { values = [], operator } = searchParams?.filter?.[dataIndex] ?? {
		values: []
	};

	const handleChangeValue = ({ valueIndex, valueItem }) => {
		handleChangeFilterValue({
			dataIndex,
			valueIndex,
			valueItem,
			defaultSearchType: column.defaultSearchType
		});
	};

	const handleChangeValue1 = valueItem => {
		handleChangeValue({
			valueIndex: 0,
			valueItem
		});
	};

	const handleChangeValue2 = valueItem => {
		handleChangeValue({
			valueIndex: 1,
			valueItem
		});
	};

	const handleSearch = () => {
		fetchList({ ...searchParams, search: filter, pageSize: tableState.pageSize, page: 1 });
		close();
	};

	const onPressEnter = () => handleSearch();

	return (
		<div className="pp_tbl_filter" onKeyDown={e => e.stopPropagation()}>
			<Space direction="vertical" size={8} className="pp_tbl_filter_inputs">
				{dataType !== "date" && (
					<Select
						className="pp__tbl__filter__input"
						options={FILTER_TYPES.map(type => ({
							label: FILTER_TYPES_DICTIONARY[type],
							value: type
						}))}
						value={values?.[0]?.searchType}
						onChange={searchType => handleChangeValue1({ searchType })}
					/>
				)}

				{getInput({
					inputType: column?.instance,
					enums: column?.enum,
					enumDictionary: column?.enumDictionary,
					value: values?.[0]?.value,
					onChange: value => handleChangeValue1({ value }),
					onPressEnter
				})}

				{values?.[0]?.value && (
					<>
						{dataType !== "date" && (
							<div className="pptable_filter_rgroup_wrapper">
								<Radio.Group
									value={operator}
									onChange={e =>
										handleChangeFilterOperator({
											dataIndex,
											value: e.target.value
										})
									}>
									{["AND", "OR"].map(opn => (
										<Radio value={opn.toLowerCase()} key={opn}>
											{opn}
										</Radio>
									))}
								</Radio.Group>
							</div>
						)}

						{dataType !== "date" && (
							<Select
								className="pp__tbl__filter__input"
								options={FILTER_TYPES.map(type => ({
									label: FILTER_TYPES_DICTIONARY[type],
									value: type
								}))}
								value={values?.[1]?.searchType}
								onChange={val => handleChangeValue2({ searchType: val })}
							/>
						)}

						{getInput({
							inputType: column?.instance,
							enums: column?.enum,
							enumDictionary: column?.enumDictionary,
							value: values?.[1]?.value,
							onChange: value => handleChangeValue2({ value }),
							onPressEnter
						})}
					</>
				)}
			</Space>

			<div className="pp_tbl_filter_action_container">
				<Button onClick={() => resetFilter(dataIndex)} type="text" className="btn_reset">
					Шинэчлэх
				</Button>

				<Button type="primary" onClick={handleSearch}>
					Хайх
				</Button>
			</div>
		</div>
	);
};

export default PPTableFilter;
